import GTMScript from "@/component/Ads/GTMScript";
import WebpageSchema from "@/component/SeoTags/WebpageSchema";
import { getDataFromSSR } from "@/handlers/client/commonClient";
import { useWindowSize } from "@/hooks/useIsMobile";
import {
  apstagBidCallback,
  createApsSlotsRosDesktop,
  createApsSlotsRosMobile,
  requestBiddingFromPWT,
} from "@/utils/ads";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { useCallback, useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";

const List1 = dynamic(() => import("@/component/Listing/List1"));
const List2 = dynamic(() => import("@/component/Listing/List2"));
const HeadTag = dynamic(() => import("@/component/SeoTags/HeadTag"));
const BreadcrumbSchema = dynamic(() =>
  import("@/component/SeoTags/BreadcrumbSchema")
);
const Breadcrumb = dynamic(() => import("@/component/Breadcrumb"));
const NoData = dynamic(() => import("@/component/NoData"));
// const Pagination = dynamic(() => import("@/component/Pagination"));
const AdSlot300x250 = dynamic(() => import("@/component/Ads/AdSlot300x250"));
const AdSlot728x90 = dynamic(() => import("@/component/Ads/AdSlot728x90"));
const VDOAdsScript = dynamic(() => import("@/component/Ads/VDOAdsScript"));
// const VDOAdSlot = dynamic(() => import("@/component/Ads/VDOAdSlot"));

const AuthorDetail = ({
  authorDetail,
  authorPosts,
  isMobileDevice = false,
}) => {
  const [currentPage, setCurrentPage] = useState(0);
  // const totalPages = authorPosts?.pagination_cap
  //   ? parseInt(authorPosts?.pagination_cap)
  //   : 10;
  const [authorPostData, setAuthorPostData] = useState(
    authorPosts ? authorPosts : []
  );
  const [hasMore, setHasMore] = useState(true);
  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const [y, setY] = useState(
    typeof window !== "undefined" && document.scrollingElement.scrollHeight
  );
  const [scrollDirection, setScrollDirection] = useState(
    "you have not scrolled yet"
  );
  // const totalPages = categoryNewsListData?.pagination_cap
  //   ? parseInt(categoryNewsListData?.pagination_cap)
  //   : 10;
  const router = useRouter();

  // const handlePageClick = (page) => {
  //   if (currentPage === page) return;
  //   setCurrentPage(page);
  //   let currentPath = router?.asPath?.split("?")[0];
  //   window.location.href = `${currentPath}?page=${page}`;
  // };
  useEffect(() => {
    setTimeout(() => {
      window.googletag = window.googletag || { cmd: [] };

      if (window.screen.width < 900) {
        googletag.cmd.push(function () {
          googletag.destroySlots();

          googletag
            .defineSlot(
              "/1007232/News_tak_Mobile_ROS_ATF_300x250",
              [300, 250],
              "div-gpt-ad-1659434453897-0"
            )
            .addService(googletag.pubads());
          googletag
            .defineSlot(
              "/1007232/News_tak_Mobile_ROS_BTF_300x250",
              [300, 250],
              "div-gpt-ad-1659435474737-0"
            )
            .addService(googletag.pubads());
          googletag
            .defineSlot(
              "/1007232/News_tak_Mobile_ROS_Bottom_320x50",
              [320, 50],
              "div-gpt-ad-1659435612077-0"
            )
            .addService(googletag.pubads());

          // googletag.pubads().enableSingleRequest();
          // googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          googletag.setConfig({ disableInitialLoad: true });
          googletag.cmd.push(function () {
            var INTERSTITIALAd = googletag
              .defineOutOfPageSlot(
                "/1007232/News_tak_Mobile_ROS_Mweb_Interstitial",
                googletag.enums.OutOfPageFormat.INTERSTITIAL
              )
              .addService(googletag.pubads());
            googletag.display(INTERSTITIALAd);
          });
        });
      } else {
        googletag.cmd.push(function () {
          googletag.destroySlots();
          googletag
            .defineSlot(
              "/1007232/News_tak_Desktop_ROS_ATF_728x90",
              [728, 90],
              "div-gpt-ad-1659424515060-0"
            )
            .addService(googletag.pubads());
          googletag
            .defineSlot(
              "/1007232/News_tak_Desktop_ROS_ATF_300x250",
              [300, 250],
              "div-gpt-ad-1707804176041-1"
            )
            .addService(googletag.pubads());
          googletag
            .defineSlot(
              "/1007232/News_tak_Desktop_ROS_MTF_1_728x90",
              [728, 90],
              "div-gpt-ad-1707804176041-2"
            )
            .addService(googletag.pubads());
          // googletag.pubads().enableSingleRequest();
          // googletag.pubads().disableInitialLoad();
          googletag.setConfig({ disableInitialLoad: true });
          googletag.enableServices();
          requestBiddingFromPWT();
        });
      }
      window.apstag?.fetchBids(
        {
          slots:
            window.screen.width < 900
              ? createApsSlotsRosMobile({ mtf2: false, mtf3: false })
              : createApsSlotsRosDesktop({ mtf2: false, mtf3: false }),
          timeout: 2e3,
        },
        apstagBidCallback
      );
    }, 10);
    try {
      // page query params
      const page = parseInt(router?.query?.page);
      if (page) {
        setCurrentPage(parseInt(page));
      }
    } catch (error) {
      console.error(error);
    }
  }, []);

  const [insightref, insightView] = useInView({
    threshold: 0,
    rootMargin: "30%",
  });
  const [mobileInsightref, mobInsightView] = useInView({
    threshold: 0,
    rootMargin: "30%",
  });

  const getMorePost = async () => {
    const websiteUrl = process.env.NEXT_PUBLIC_WEBSITE_URL;
    setLoadingSpinner(true);
    const fetchedData = await getDataFromSSR(
      `${websiteUrl}/api/getAuthorPosts?page=${currentPage}&slug=${router?.query?.slug}`
    );
    if (fetchedData?.data?.authorPosts?.length > 0) {
      setAuthorPostData([...authorPostData, ...fetchedData?.data?.authorPosts]);
    } else {
      setHasMore(false);
    }
    setLoadingSpinner(false);
  };
  const handleNavigation = useCallback(
    (e) => {
      if (y > window.scrollY) {
        setScrollDirection("Scrolling Up");
      } else if (y < window.scrollY) {
        setScrollDirection("Scrolling Down");
      }
      setY(window.scrollY);
    },
    [y]
  );
  useEffect(() => {
    window.addEventListener("scroll", handleNavigation);

    return () => {
      window.removeEventListener("scroll", handleNavigation);
    };
  }, [handleNavigation]);

  useEffect(() => {
    if (
      (insightView || mobInsightView) &&
      scrollDirection == "Scrolling Down" &&
      hasMore
    ) {
      setCurrentPage(currentPage + 1);
    }
  }, [insightView, mobInsightView, scrollDirection]);

  useEffect(() => {
    currentPage > 0 && getMorePost();
    let height = window?.scrollY;
    window.scrollTo(0, height);
  }, [currentPage]);

  const size = useWindowSize();

  return (
    <section>
      <Breadcrumb breadcrumbList={authorDetail?.category_detail} />
      <HeadTag
        title={authorDetail?.seo_detail?.meta_title}
        description={authorDetail?.seo_detail?.meta_description}
        image={authorDetail?.seo_detail?.og_image}
        keywords={authorDetail?.seo_detail?.meta_keyword}
        canonicalUrl={
          process.env.NEXT_PUBLIC_WEBSITE_URL +
          authorDetail?.seo_detail?.canonical_url
        }
        lcpImage={authorDetail?.profile_image}
      />
      <WebpageSchema
        title={authorDetail?.title ?? authorDetail?.seo_detail?.meta_title}
        description={authorDetail?.seo_detail?.meta_description}
        keywords={authorDetail?.seo_detail?.meta_keyword}
        canonicalUrl={
          process.env.NEXT_PUBLIC_WEBSITE_URL +
          authorDetail?.seo_detail?.canonical_url
        }
      />
      <GTMScript />
      <BreadcrumbSchema breadcrumbList={authorDetail?.category_detail} />
      {/* <VDOAdsScript /> */}

      <header className="bg-[#f7f7f7] m-4 rounded-md">
        <div className="flex items-center justify-center px-4 sm:px-6 lg:px-8 py-2 sm:flex-row flex-col text-center sm:text-left">
          <img
            src={
              authorDetail?.profile_image ??
              "https://cdn-icons-png.flaticon.com/512/847/847969.png"
            }
            alt="Profile"
            className="rounded-full hidden object-cover mb:block xs:block w-24 h-24 border-2 p-1 border-primary"
          />
          <div className="flex items-center mb-4">
            <img
              src={authorDetail?.profile_image ?? "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/authorDefault.png"}
              alt="Profile"
              fetchpriority="high"
              className="rounded-full object-cover sm:w-24 sm:h-24 w-16 h-16 mb:hidden xs:hidden border-2 p-1 border-primary"
            />
            <div className="ml-0  md:ml-4 lg:ml-4 flex flex-col justify-center">
              <h1 className="text-xl font-semibold text-gray-900 pt-2">
                {authorDetail?.title}
              </h1>
              <div className="text-sm text-gray-500">
                {authorDetail?.email_id}
              </div>
              {authorDetail?.description && (
                <div
                  className="text-sm text-gray-500 mt-2 ml-2 text-justify"
                  dangerouslySetInnerHTML={{
                    __html: authorDetail?.description,
                  }}
                />
              )}
              <div className="flex flex-wrap  md:flex-row  justify-center items-center gap-1 my-5 text-gray-600 w-full">
                {/* Email */}
                {authorDetail?.email_id && (
                  <a
                    href={`mailto:${authorDetail?.email_id}`}
                    className="flex items-center   hover:text-primary min-w-0"
                  >
                    <img
                      src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/email_icon.png"
                      alt="Email"
                      className="w-5 h-5 mx-1"
                    />
                    <span className="hidden sm:inline text-sm hover:text-primary  ">
                      {authorDetail?.email_id}
                    </span>
                  </a>
                )}

                {/* Facebook */}
                {authorDetail?.facebook_id && (
                  <a
                    href={authorDetail?.facebook_id}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center mx-2  underline min-w-0"
                  >
                    <img
                      src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/facebook_icon.png"
                      alt="Facebook"
                      className="w-5 h-5 mx-1"
                    />
                    <span className="hidden sm:inline text-sm hover:text-primary ">
                      {authorDetail?.facebook_id
                        ?.split("facebook.com/")[1]
                        ?.replace("/", "")}
                    </span>
                  </a>
                )}

                {/* Twitter */}
                {authorDetail?.twitter_handle && (
                  <a
                    href={authorDetail?.twitter_handle}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center  underline min-w-0"
                  >
                    <img
                      src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/twitter_icon.png"
                      alt="Twitter"
                      className="w-5 h-5 mx-1"
                    />
                    <span className="hidden sm:inline text-sm hover:text-primary  ">
                      {authorDetail?.twitter_handle
                        ?.split("x.com/")[1]
                        ?.replace("/", "")}
                    </span>
                  </a>
                )}

                {/* Instagram */}
                {authorDetail?.instagram_handle && (
                  <a
                    href={authorDetail?.instagram_handle}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center mx-3 underline min-w-0"
                  >
                    <img
                      src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/instagram_icon.png"
                      alt="Instagram"
                      className="w-5 h-5 mx-1"
                    />
                    <span className="hidden sm:inline text-sm hover:text-primary  ">
                      {authorDetail?.instagram_handle
                        ?.split("instagram.com/")[1]
                        ?.replace("/", "")}
                    </span>
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </header>

      <section className="mx-4 md:mx-4 md:px-2 py-2">
        <AdSlot300x250
          divId="div-gpt-ad-1659434453897-0"
          minWidth="300px"
          minHeight="250px"
        />

        <AdSlot728x90
          divId="div-gpt-ad-1659424515060-0"
          minWidth="720px"
          minHeight="90px"
        />

        {isMobileDevice ? (
          <div className="hidden md:hidden lg:hidden sm:block mb:block xs:block md-hidden">
            {size.width < 900 && (
              <List1
                title={`${authorDetail?.title} की खबरें`}
                newsListData={authorPostData}
                showAds={isMobileDevice ? true : false}
              />
            )}
            <div
              className="text-sports news-load h-[50px] w-full mb-4"
              ref={mobileInsightref}
            >
              {loadingSpinner === true && (
                <div className="flex items-center justify-center">
                  <div className="animate-spin rounded-full border-t-4 border-primary border-solid h-12 w-12"></div>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="hidden mb-block md:block lg:block">
            {size.width > 900 && (
              <List2
                title={`${authorDetail?.title} की खबरें`}
                newsListData={authorPostData}
                showAds={isMobileDevice ? true : false}
              />
            )}
            <div
              className="text-sports news-load h-[50px] w-full mb-4"
              ref={insightref}
            >
              {loadingSpinner === true && (
                <div className="flex items-center justify-center">
                  <div className="animate-spin rounded-full border-t-4 border-primary border-solid h-12 w-12"></div>
                </div>
              )}
            </div>
          </div>
        )}

        {authorPostData?.length === 0 && <NoData message="No Posts yet" />}
        <AdSlot300x250
          divId="div-gpt-ad-1659435474737-0"
          minWidth="300px"
          minHeight="250px"
        />
        <AdSlot728x90
          divId="div-gpt-ad-1707804176041-2"
          minWidth="720px"
          minHeight="90px"
        />
        {/* <Pagination
          handlePageClick={handlePageClick}
          currentPage={currentPage}
          totalPages={totalPages}
        /> */}
      </section>
    </section>
  );
};

export default AuthorDetail;
